import { createSelector } from "reselect";
import { RootState, selectState } from "../../store";
import {
  getSelectedDrawersData,
  getSelectedSiteIdFromDrawer
} from "./drawerSelectors";
import siteApi from "../api/site";

export const getSelectedSiteSection = (state: RootState) =>
  state.site.selectedSiteSection;

export const getCurrentOpenSiteView = (state: RootState) =>
  state.site.currentOpenSiteView;

export const getCurrentlyUsedEnvironmentsForSelectedSite = (state: RootState) =>
  state.site.currentlyUsedEnvironmentIds;

export const getHasRequiredSiteOperationData = (state: RootState) =>
  state.site.siteOperationTempData.hasRequiredSiteDataReady;

export const getSavedPendingSiteEditsBySite = (
  state: RootState
): { [x: string]: PendingChangesListType } => state.site.savedPendingSiteEdits;

export const getCurrentSitePendingConfigurationItemsList = (
  state: RootState
): PendingChangesListType => state.site.pendingChangesList;

export const getPendingConfigurationItemsList = createSelector(
  [
    getSavedPendingSiteEditsBySite,
    getCurrentSitePendingConfigurationItemsList,
    getSelectedDrawersData
  ],
  (
    savedPendingSiteEdits,
    currentSitePendingConfigurations,
    selectedDrawersData
  ) => {
    const siteId = selectedDrawersData.site?.id || "";
    const possibleSavedConfigurationsEdits =
      savedPendingSiteEdits && savedPendingSiteEdits?.[siteId];

    if (
      !Object.keys(currentSitePendingConfigurations).length &&
      possibleSavedConfigurationsEdits
    ) {
      return possibleSavedConfigurationsEdits;
    }
    return currentSitePendingConfigurations;
  }
);

export const getSiteOperationTempData = (state: RootState) =>
  state.site.siteOperationTempData;

export const selectArePendingChangesAvailable = createSelector(
  [getPendingConfigurationItemsList],
  (pendingConfigurationChangesList) =>
    !!Object.keys(pendingConfigurationChangesList).length
);

export const getCurrentSiteConfigurationTypes = createSelector(
  [getSelectedSiteIdFromDrawer, selectState],
  (
    siteId,
    state
  ): {
    currentSiteConfigurationsTypes: { id: string; name: string }[];
    configurationMenuType: SiteConfigurationMenuGroupings | null;
    numberOfConfigurationsTypes: number;
  } => {
    if (siteId) {
      const { data } = siteApi.endpoints.getSiteConfigurationsList.select({
        siteId
      })(state);
      return {
        currentSiteConfigurationsTypes: Object.keys(
          data?.allConfigurationsMenuTypes || {}
        ).map((configurationType) => {
          const configurationTypeDetails = (data?.allConfigurationsMenuTypes[
            configurationType
          ] ?? null) as {
            configurationTypeName: string;
            configurationTypeId: string;
            displayOrder: number;
          } | null;

          return {
            id: configurationType,
            name: configurationTypeDetails?.configurationTypeName || ""
          };
        }),
        configurationMenuType: data?.allConfigurationsMenuTypes || null,
        numberOfConfigurationsTypes: Object.keys(
          data?.allConfigurationsMenuTypes || {}
        ).length
      };
    }
    return {
      currentSiteConfigurationsTypes: [],
      configurationMenuType: null,
      numberOfConfigurationsTypes: 0
    };
  }
);
